import React from "react";
import {Col, Row} from "react-bootstrap";

const PageSubTitle = ({title, buttons, image}) => {
  return (
    <Row>
      <Col>
        <div className="page-title">
          <h4>{image} {title}</h4>
        </div>
      </Col>
      {buttons &&
        <Col className='col-auto text-end align-self-center'>
          {buttons}
        </Col>
      }
      <hr/>
    </Row>
  )
};

export default PageSubTitle;